import React, {FC} from "react";
import logo from "../../../assets/images/logo.png";
import {CORE_BASE_URL, CouponType} from "../../../bll/types";
import {Rate} from "antd";

type PropsType = {
    coupon: CouponType
}
export const Product: FC<PropsType> = ({coupon}) => {
    return <div className="list-of-shop">
        <div className="container">
            <div className="item">
                <div className="icon">
                    <img src={`${CORE_BASE_URL}/Default/General/Image/${coupon.userId}?type=UserImage`}/>
                </div>
                <div className="description">
                    <div className="name-shop">
                        <a
                            href={`${CORE_BASE_URL}/user/${coupon.userId}`}
                            target={'_blank'}>{coupon.customerName}</a>
                        {coupon.customerShopRating !== 0 && <div className="reviews">
                            <Rate disabled allowHalf defaultValue={coupon.customerShopRating / 2} />
                        </div>}
                    </div>
                    {coupon.customerShopRating !== 0 ? <div className="text-description">
                            <div className="customerFeedback">{coupon.customerFeedback}</div>
                            <button>Купил {coupon.productTitle}</button>
                        </div> :
                        <div className="product">
                            <button>Купил {coupon.productTitle}</button>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}